
    import { computed, ComputedRef, defineComponent, reactive, SetupContext } from 'vue'

    import { StoreState, setEmail, setName, setWebSocketToken, setUser } from '@/store'
    import useStore from '@/hooks/useStore'
    import useNavigation from '@/hooks/useNavigation'
    // import useChat from '@/hooks/useChat'
    import services from '@/services'

    import Icon from '@/components/Icon/IndexIcon.vue'
    import FormInput from '@/components/Form/FormInput.vue'
    import CloseButton from '@/components/webchat/CloseButton.vue'

    type State = {
        name: string
        email: string
        isLoading: boolean
        hasError: Error | null
    }

    type Validation = {
        name: string
        email: string
    }

    interface SetupReturn {
        store: StoreState
        emit: SetupContext['emit']

        handleSelect (type: string): void

        state: State
        validation: Validation
        submitButtonIsDisable: ComputedRef<boolean>

        onSubmit (): Promise<void>

        validateState (key: keyof State): void
    }

    export default defineComponent({
        components: {
            CloseButton,
            FormInput,
            Icon
        },

        emits: ['select-type', 'next', 'close-box'],

        setup (_, { emit }: SetupContext): SetupReturn {
            const store = useStore()
            // const { startChat } = useChat()
            const {
                setErrorState,
                next
            } = useNavigation()

            const state = reactive<State>({
                name: store.name,
                email: store.email,
                isLoading: false,
                hasError: null
            })

            const validation = reactive<Validation>({
                name: '',
                email: ''
            })

            const submitButtonIsDisable = computed<boolean>(() => {
                const length = state.name.length > 0 && state.email.length > 0
                const inputError = document.querySelectorAll('.input_error').length === 0
                return length && inputError
            })

            async function onSubmit (): Promise<void> {
                state.isLoading = true
                if (state.name.length === 0 || state.email.length === 0) {
                    // TODO: Refactor this return
                    alert('Preencha o nome e o email')
                    return
                }

                try {
                    const response = await services.webchat.start({
                        name: state.name,
                        email: state.email,
                        page: store.currentPage,
                        apiKey: store.apiKey,
                        device: window.navigator.userAgent
                    })

                    if (response.errors) {
                        setErrorState()
                        return
                    }

                    setEmail(state.email)
                    setName(state.name)
                    setUser(response.user)
                    setWebSocketToken(response.token)
                    next()
                } catch (error) {
                    handleError(error as Error)
                }
                state.isLoading = false
            }

            function setErrorValidate (key: keyof Validation, value: string): void {
                validation[key] = value
            }

            function validateState (key: keyof Validation): void {
                const vEmail = /\S+@\S+\.\S+/

                if (key === 'email' && !vEmail.test(state[key])) {
                    setErrorValidate(key, 'Informar um email válido')
                } else if (state[key].length === 0) {
                    setErrorValidate(key, 'Este campo é obrigatório')
                } else {
                    setErrorValidate(key, '')
                }
            }

            function handleError (error: Error) {
                state.hasError = error
                state.isLoading = false
                setErrorState()
            }

            function handleSelect (): void {
                try {
                    next()
                } catch (e) {
                    handleError(e as Error)
                }
            }

            return {
                store,
                emit,
                handleSelect,
                state,
                validation,
                submitButtonIsDisable,
                onSubmit,
                validateState
            }
        }
    })
